import { render, staticRenderFns } from "./navbarHeader.vue?vue&type=template&id=2a8845a0&scoped=true&"
import script from "./navbarHeader.vue?vue&type=script&lang=js&"
export * from "./navbarHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8845a0",
  null
  
)

export default component.exports